import React from "react";

import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import DeleteAccount from "@scenes/more/DeleteAccountScreen";

const DeleteAccountModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      paddingTop={16}
      headerTitle={t("navigation.profile.general.label.deleteAccount")}
    >
      <DeleteAccount />
    </Modal>
  );
};

export default DeleteAccountModal;
